import { render } from "./ProjectFile.vue?vue&type=template&id=76859fae"
import script from "./ProjectFile.vue?vue&type=script&lang=js"
export * from "./ProjectFile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__